import { render } from "./WenAnAiCrateView.vue?vue&type=template&id=322c523f&scoped=true"
import script from "./WenAnAiCrateView.vue?vue&type=script&lang=js"
export * from "./WenAnAiCrateView.vue?vue&type=script&lang=js"

import "./WenAnAiCrateView.vue?vue&type=style&index=0&id=322c523f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322c523f"]])

export default __exports__